export { default as Home } from './Home';
export { default as Recruit } from './Recruit';
export { default as Service } from './Service';
export { default as News } from './News';
export { default as Works } from './Works';
export { default as Voice } from './Voice';
export { default as Company } from './Company';
export { default as Contact } from './Contact';
export { default as Post } from './Post';